import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardContainer from './CardContainer';
// import EventFab from './EventFab';

const styles = theme => ({
    section: {
        [theme.breakpoints.up('md')]: {
            marginLeft: 330,
            fontSize: 18
        },
        marginBottom: 18,
        
        fontSize: 16,
    },
    toolbar: theme.mixins.toolbar,
});

class EventDetails extends React.Component {
    state = {
        anchorEl: null,
    };
    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    onSetResult = (result) => {
        if (result.id === 1) {
            let dtlId = parseInt(this.props.match.params.dtlId,10);
            let dtls = result.eventDetails || [];
            let g = dtls.find(y => y.id === dtlId) || dtls[0] || {};
            this.props.updateTitle(result.description,g.when,result.id,g.id);
            this.props.setEvent(result.id,g.id);
        }
        else {
            this.props.updateTitle(result.description,result.when,result.id,NaN);
            this.props.setEvent(result.id,-1);
        }
    };

    componentWillMount() {
        // Change it to 1 to show Pre-cons
        let evtId = parseInt(this.props.match.params.id,10) || 2;
        fetch("https://www.seatingsymposium.us/app/rest/events/"+evtId).then(response => response.json()).then(result => this.onSetResult(result));
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillUpdate({ location, history }) {
        const gtag = window.gtag
        
        if (location.pathname === this.props.location.pathname) {
          return
        }
        
        // if (history.action === 'PUSH' && typeof(gtag) === 'function') {
        //   gtag('config', 'UA-115311410-1', {
        //     'page_location': window.location.href,
        //     'page_path': location.pathname,
        //   })
        // }
      }

    render() {
        const { events, classes,displayLoadIndicator } = this.props;
        // Change it to 1 to show Pre-cons
        let evtId = parseInt(this.props.match.params.id,10) || 2;
        let dtlId = parseInt(this.props.match.params.dtlId,10);
        let schId = parseInt(this.props.match.params.schId,10);
        let evt = events.find(x => x.id === evtId) || {};
        let dtls = evt.eventDetails || [];
        let g = dtls.find(y => y.id === dtlId) || dtls[0] || {};
        let schedules = g.schedules || [];
        
        return (
            <div>
                {schedules.map((item,itemKey) => {
                    
                    if (!item.link) {
                        if(isNaN(schId)) {
                            return(<Typography key={itemKey+item.description} className={classes.section} component="h1" color="textSecondary">
                                {item.timeRange}: {item.description}
                                </Typography>
                            );
                        }
                        else {
                            return null;
                        }
                    }
                    
                    else {
                        if (schId === item.id) {
                            return(
                                <div key={item.id}>
                                    <Typography key={itemKey} className={classes.section} component="h1" color="textSecondary">
                                        {item.timeRange}: {item.description}
                                    </Typography>
                                    <CardContainer key={item.description} scheduleid={item.id} displayLoadIndicator={displayLoadIndicator}/>
                                </div>
                            );
                        }
                        else if (isNaN(schId)) {
                            return(
                                <div key={item.id}>
                                    <Typography key={itemKey} className={classes.section} component="h1" color="textSecondary">
                                        {item.timeRange}: {item.description}
                                    </Typography>
                                    <CardContainer key={item.description} scheduleid={item.id} displayLoadIndicator={displayLoadIndicator}/>
                                </div>
                            );
                        }
                        else {
                            return null;
                        }
                    }
                })}
                
                {/* <div className={classes.toolbar}></div>

                <EventFab schedules={schedules} evtId={evtId} dtlId={dtlId}/> */}
                
            </div>
        );
    }

}

EventDetails.propTypes = {
    events: PropTypes.array.isRequired,
    updateTitle: PropTypes.func,
    setEvent: PropTypes.func,
    displayLoadIndicator: PropTypes.func,
};

export default withStyles(styles)(EventDetails);